/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  // Set StayAI ATC Price event listener
  const formId = document.querySelector('product-form [name="id"]')
  setStayPriceListener()
  window.addEventListener('stay-ai-subscription-changed', setStayPriceListener)
  formId.addEventListener('change', () => {
    setTimeout(() => {
      setStayPriceListener()
    }, 10);
  })

  function setStayPriceListener() {
    const productATCPrice = document.querySelector('.product__submit__buttons .btn__price')
    const selectedPurchaseType = document.querySelector('input[name="purchaseType"]:checked');
    const subPrice = document.querySelector('.stayai-subscriptions [data-stayai-subscription-price]')
    const ogPrice = document.querySelector('.stayai-subscriptions [data-stayai-onetime-price]')

    if (!productATCPrice || !selectedPurchaseType) return
    
    const subFullPrice = subPrice.querySelector('.fullPrice')?.innerText || ''
    const price = selectedPurchaseType.value.toLowerCase().includes('subscription') 
      ?  subPrice.innerText.replace(subFullPrice, '').replace(/\s/g, '') 
      : ogPrice.innerText.replace(/\s/g, '')
    productATCPrice.innerText = price
  }

})();